export default __webpack_public_path__ + "static/media/clipboard-delete.2ce6ef5b.svg";